import { apiClient } from './apiClient';

export type CountryOption = {
  id: string;
  name: string;
  continent: string;
};

export type StateOption = {
  id: string;
  name: string;
  countryId: string;
};

export type CityOption = {
  id: string;
  name: string;
  stateId: string;
};

export async function listCountries(): Promise<CountryOption[]> {
  const response = await apiClient.get<CountryOption[]>('/v1/locations/countries');
  return response.data;
}

export async function listStates(countryId: string): Promise<StateOption[]> {
  const response = await apiClient.get<StateOption[]>('/v1/locations/states', {
    params: { countryId },
  });
  return response.data;
}

export async function listCities(stateId: string): Promise<CityOption[]> {
  const response = await apiClient.get<CityOption[]>('/v1/locations/cities', {
    params: { stateId },
  });
  return response.data;
}
